<ion-app>
  @if (isLoading()) {
    <div id="full-page-loader"
         class="transition-opacity-600">
      <ion-spinner color="tertiary" />
    </div>
  }

  <ion-menu contentId="main-outlet"
            menuId="main-menu"
            swipe-gesture="false">
    <ion-content color="tertiary">
      <div>
        <div class="ion-padding text-center">
          <img class="mt-6" src="assets/img/dabay_logo-only.svg" alt="DaBay" />
          <p class="text-s">Die <strong>Dialektapp Bayern</strong> ist ein Projekt an der Ludwig-Maximilians-Universität
            München.</p>
        </div>

        <ion-menu-toggle>
          <ion-list id="main-menu">
            <ion-item color="tertiary"
                      routerLink="/">Startseite
              @if (!auth.isLoggedIn()) {
                <ion-chip class="text-xxs" color="warning" slot="end">Nur mit Anmeldung</ion-chip>
              }
            </ion-item>
            <ion-item color="tertiary"
                      routerLink="/blog">Themen & News
            </ion-item>
            <ion-item color="tertiary"
                      routerLink="/ranking">Rangliste
              @if (!auth.isLoggedIn()) {
                <ion-chip class="text-xxs" color="warning" slot="end">Nur mit Anmeldung</ion-chip>
              }
            </ion-item>
            <ion-item color="tertiary"
                      routerLink="/archive">Archiv
              @if (!auth.isLoggedIn()) {
                <ion-chip class="text-xxs" color="warning" slot="end">Nur mit Anmeldung</ion-chip>
              }
            </ion-item>
            <ion-item color="tertiary"
                      routerLink="/about">Über DaBay
            </ion-item>
            <ion-item color="tertiary"
                      routerLink="/faq">FAQ
            </ion-item>
            <ion-item color="tertiary"
                      href="/assets/files/dabay-datenschutz.pdf"
                      target="_blank"
                      lines="none">Rechtliches
            </ion-item>
          </ion-list>
        </ion-menu-toggle>
      </div>

      <p class="ion-padding-horizontal text-xxs">&copy; {{ copyright }} LMU München - Version {{ version }}</p>
    </ion-content>
  </ion-menu>

  <ion-router-outlet id="main-outlet"></ion-router-outlet>
</ion-app>
